<template>
  <div class="card  p-3">
    <div class="row">
      <div class="col-1">
        <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="flat-danger"
            @click.stop="$router.push({ name: 'chats' })"
        >
          Voltar
        </b-button>
      </div>

    </div>
    <h3 class="mt-2">Resumo Lead</h3>
    <div class="mt-2">
      <b-list-group>
        <b-list-group-item class="d-flex row">
          <div>
          <p
              class="col-12"
          >
            <strong>  Chat : </strong>  {{ lead[0].name }}
          </p>
          </div>
          <div
            v-for="mensagem in lead"
            :key="mensagem.id"
          >
            <p
              class="col-12"
            >
              <strong>{{ mensagem.label }} : </strong>  {{ mensagem.value }}
            </p>
          </div>
          <div
          >
            <p
              class="col-12"
            >
              <strong>Url : </strong>  {{ lead[0].page }}
            </p>
          </div>
          <div
          >
            <p
                class="col-12"
            >
                <strong>Origem : </strong>  {{ lead[0].origem }}
            </p>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>

  </div>

</template>

<script>
import { BListGroup, BListGroupItem ,BButton } from 'bootstrap-vue'
import { useApi } from '@/composables/useApi'


const apiBack = useApi()
export default {
  components: {
    BListGroup,
    BListGroupItem,
    BButton
  },
  data() {
    return {
      leadId: this.$route.params.id_lead,
      lead: [],
    }
  },
  mounted() {
    this.detalheLead()
  },
  methods: {
    async detalheLead() {
      await apiBack.get(`lead/${this.leadId}`)
        .then(response => {
          this.lead = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
